export default __webpack_public_path__ + "static/media/ic_arrowleft16.9d2319ed.svg";